import { render, staticRenderFns } from "./PayoutsPaidMiniCard.vue?vue&type=template&id=407156c5&"
import script from "./PayoutsPaidMiniCard.vue?vue&type=script&lang=js&"
export * from "./PayoutsPaidMiniCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports